/**
 * Company 페이지 번역 데이터
 */

import type { CompanyTranslations } from './types';

export const companyTranslations: Record<'ko' | 'es' | 'en', CompanyTranslations> = {
  ko: {
    title: '세금계산서 발급',
    subtitle: '세금계산서를 받을 회사를 선택하세요',
    addNewCompany: '새 회사 등록',
    registeredCompanies: '등록된 회사',
    companyName: '회사명',
    rfc: 'RFC (사업자등록번호)',
    address: '주소',
    phone: '전화번호',
    email: '이메일',
    city: '도시',
    state: '주/도',
    register: '등록하기',
    cancel: '취소',
    rfcPlaceholder: 'ABC123456789',
    phonePlaceholder: '+52 55 0000 0000',
    emailPlaceholder: 'company@example.com',
    selectCompany: '선택',
    noCompanies: '등록된 회사가 없습니다',
    addFirstCompany: '첫 번째 회사를 등록해보세요',
    required: '필수',
    companyRegistered: '회사가 성공적으로 등록되었습니다',
    fillRequired: '필수 항목을 모두 입력해주세요',
    edit: '수정',
    taxRegime: '세금 체계 (Régimen Fiscal)',
    cfdiUse: 'CFDI 사용 목적',
    postalCode: '우편번호',
    selectRegimen: '세금 체계 선택',
    selectUso: 'CFDI 사용 목적 선택',
    postalCodePlaceholder: '01000',
    delete: '삭제',
    deleteConfirmTitle: '회사 삭제',
    deleteConfirmMessage: '정말로 이 회사를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    confirmDelete: '삭제',
    companyDeleted: '회사가 삭제되었습니다',
    companyUpdated: '회사 정보가 수정되었습니다',
    editCompany: '회사 정보 수정'
  },
  es: {
    title: 'Emitir Factura Electrónica',
    subtitle: 'Selecciona la empresa que recibirá la factura',
    addNewCompany: 'Registrar Nueva Empresa',
    registeredCompanies: 'Empresas Registradas',
    companyName: 'Nombre de la Empresa',
    rfc: 'RFC',
    address: 'Dirección',
    phone: 'Teléfono',
    email: 'Correo Electrónico',
    city: 'Ciudad',
    state: 'Estado',
    register: 'Registrar',
    cancel: 'Cancelar',
    rfcPlaceholder: 'ABC123456789',
    phonePlaceholder: '+52 55 0000 0000',
    emailPlaceholder: 'empresa@ejemplo.com',
    selectCompany: 'Seleccionar',
    noCompanies: 'No hay empresas registradas',
    addFirstCompany: 'Registra tu primera empresa',
    required: 'Requerido',
    companyRegistered: 'Empresa registrada exitosamente',
    fillRequired: 'Por favor completa todos los campos requeridos',
    edit: 'Editar',
    delete: 'Eliminar',
    deleteConfirmTitle: 'Eliminar Empresa',
    deleteConfirmMessage: '¿Está seguro de que desea eliminar esta empresa? Esta acción no se puede deshacer.',
    confirmDelete: 'Eliminar',
    companyDeleted: 'Empresa eliminada',
    companyUpdated: 'Información de la empresa actualizada',
    editCompany: 'Editar Información de la Empresa',
    taxRegime: 'Régimen Fiscal',
    cfdiUse: 'Uso del CFDI',
    postalCode: 'Código Postal',
    selectRegimen: 'Selecciona el régimen fiscal',
    selectUso: 'Selecciona el uso del CFDI',
    postalCodePlaceholder: '01000'
  },
  en: {
    title: 'Issue Electronic Tax Invoice',
    subtitle: 'Select the company to receive the tax invoice',
    addNewCompany: 'Register New Company',
    registeredCompanies: 'Registered Companies',
    companyName: 'Company Name',
    rfc: 'RFC (Tax ID)',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    city: 'City',
    state: 'State',
    register: 'Register',
    cancel: 'Cancel',
    rfcPlaceholder: 'ABC123456789',
    phonePlaceholder: '+52 55 0000 0000',
    emailPlaceholder: 'company@example.com',
    selectCompany: 'Select',
    noCompanies: 'No companies registered',
    addFirstCompany: 'Register your first company',
    required: 'Required',
    companyRegistered: 'Company registered successfully',
    fillRequired: 'Please fill all required fields',
    edit: 'Edit',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete Company',
    deleteConfirmMessage: 'Are you sure you want to delete this company? This action cannot be undone.',
    confirmDelete: 'Delete',
    companyDeleted: 'Company deleted',
    companyUpdated: 'Company information updated',
    editCompany: 'Edit Company Information',
    taxRegime: 'Tax Regime (Régimen Fiscal)',
    cfdiUse: 'CFDI Usage',
    postalCode: 'Postal Code',
    selectRegimen: 'Select tax regime',
    selectUso: 'Select CFDI usage',
    postalCodePlaceholder: '01000'
  }
};
